//
//

import { mapGetters, mapMutations } from "vuex";
import { eventBus } from "@/assets/js/appFunc";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQCard from "@/components/Generics/AQCard";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import { CHECK_NAME_REGEX_STARTING_ALPHA_ONLY } from "@/assets/js/appConfig";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import shortId from "short-uuid";

export default {
    name: "AddNewClassModal",
    components: { AQModal, AQInput, AQDialog, AQCard, AQButton, AQBadge },
    props: {
        diagramInstance: { type: Object, default: () => {} },
        showAddEditData: { type: Boolean, default: false },
        classToAdd: { type: Object, default: () => {} },
        classUuid: { type: String, default: "" },
        isInEdit: { type: Boolean, default: false },
        isEdit: { type: Boolean, default: false },
        classNameFromEdit: { type: String, default: "" },
        isBCReadyFromEdit: { type: Boolean, default: false },
        parentClassArray: { type: Array, default: () => [] },
        initialClassName: { type: String, default: "" },
        temporaryClassInfo: { type: Object, default: () => {} },
        parentClassData: { type: Object, default: () => {} },
        disabledSavebtn: { type: Boolean, default: true }
    },

    data() {
        return {
            duplicateCatName: "",
            duplicatedClassNameLabel: "",
            duplicateTypeName: "",
            duplicateInTypes: false,
            showModal: false,
            newClassName: "",
            checked: false,
            noNameFound: false,
            duplicateInCatalogs: false,
            duplicatedClassName: false,
            isDisabled: false,
            noPropDialogToShow: false,
            sendBlockChainToggle: false,
            dialogPayload: "",
            bcReadyDisabled: false,
            initialBCReady: null,
            openDialog: false,
            validatePattern: new RegExp("^[a-zA-Z0-9]*[a-zA-Z_][a-zA-Z0-9_]*$"),
            propertyName: null,
            attributesArray: [],
            attrObject: [],
            addAtributeClass: null,
            initialClassData: null,
            deleteDialog: false,
            baseTypes: ["String", "Date", "Time", "DateTime", "Integer", "Boolean", "Decimal", "Attachment", "RichText"],
            hasChanges: false,
            invalidPattern: false
        };
    },

    computed: {
        ...mapGetters("apps", ["currentApp"]),
        ...mapGetters("catalogs", ["existingCatalogsAsList", "columnDataTypesWithAttDDL", "getDataModelList"]),
        titleModal() {
            return !this.isInEdit ? this.$t("dataModel.modal.title") : this.$t("dataModel.modal.editTitle");
        },
        headerActionsModel() {
            return this.isInEdit ? [{ label: this.$t("diagrams.components.setRules.delete") }] : [];
        },
        classNameError() {
            return this.noNameFound || this.duplicateInCatalogs || this.duplicatedClassName || this.duplicateInTypes || this.invalidPattern;
        },
        modalBtnLabel() {
            const label = this.isInEdit ? this.$t("generic.done") : this.$t("generic.add");
            const disabled = this.disabledSavebtn;
            return { label, disabled };
        },
        actions() {
            return this.isInEdit
                ? [
                    {
                        name: "Delete",
                        label: this.$t("generic.delete"),
                        color: "negative"
                    }
                ]
                : null;
        },
        computedClassNameFromEdit: {
            get() {
                return this.classNameFromEdit;
            },
            set(v) {
                const updateName = v.charAt(0).toUpperCase() + v.slice(1);
                this.$emit("update:classNameFromEdit", updateName);
            }
        },
        computedIsBCReadyFromEdit: {
            get() {
                for (let i = 0; i < this.parentClassArray.length; i++) {
                    let found = false;
                    if (this.parentClassArray[i].id === this.classUuid) {
                        this.parentClassArray[i].fields.forEach(item => {
                            if (item.isBCReady && !found) {
                                this.bcReadyDisabled = true;
                                found = true;
                            }
                        });
                    }
                    if (!found) {
                        this.parentClassArray[i].fields.forEach(item => {
                            if (item.type === this.classNameFromEdit && item.isBCReady && !found) {
                                this.bcReadyDisabled = true;
                                found = true;
                            }
                        });
                    }
                }
                return this.isBCReadyFromEdit;
            },
            set(v) {
                this.$emit("update:isBCReadyFromEdit", v);
            }
        },
        errorLabel() {
            let errorMessage;
            if (this.noNameFound || this.invalidPattern) {
                errorMessage = `${this.$t("dataModel.modal.noNameErrorClassName")}`;
            } else if (this.duplicateInTypes) {
                errorMessage = this.$t("dataModel.modal.duplicateInTypes", {
                    name: this.duplicateTypeName
                });
            } else if (this.duplicateInCatalogs) {
                errorMessage = this.$t("dataModel.modal.duplicateInCatalogs", {
                    name: this.duplicateCatName
                });
            } else if (this.duplicatedClassName) {
                errorMessage = this.$t("dataModel.modal.duplicateInDataModel", {
                    name: this.duplicatedClassNameLabel
                });
            }
            return errorMessage;
        },
        computedTitleDialog() {
            return this.deleteDialog ? this.$t("dataModel.modal.deleteTitleDialogClass") : this.$t("dataModel.modal.closeTitleDialog");
        },
        computedMessageBody() {
            return this.deleteDialog ? this.$t("dataModel.modal.deleteBodyMsgClass") : this.$t("dataModel.modal.closeBodyDialog");
        },
        computedBtn() {
            return this.deleteDialog ? this.$t("dataModel.modal.deleteBtnDlt") : this.$t("dataModel.modal.closeDialog");
        }
    },
    watch: {
        newClassName() {
            this.hasChanges = true;
            if (!this.newClassName || this.attrObject.length === 0) {
                this.modalBtnLabel.disabled = true;
                this.noNameFound = !this.newClassName;

                if (this.newClassName) {
                    this.newClassName = this.newClassName.charAt(0).toUpperCase() + this.newClassName.slice(1);
                    this.checkDuplicates(this.newClassName);
                    if (!this.validatePattern.test(this.newClassName)) {
                        this.noNameFound = true;
                        this.modalBtnLabel.disabled = true;
                    }
                }
            } else if (!this.validatePattern.test(this.newClassName)) {
                this.noNameFound = true;
                this.modalBtnLabel.disabled = true;
            } else if (this.validateClassName()) {
                this.noNameFound = false;
                this.modalBtnLabel.disabled = false;
                this.newClassName = this.newClassName.charAt(0).toUpperCase() + this.newClassName.slice(1);
                this.checkDuplicates(this.newClassName);
            }
        },
        computedClassNameFromEdit() {
            this.hasChanges = true;
            let className = "";
            if (this.classNameFromEdit) {
                if (!this.validatePattern.test(this.classNameFromEdit)) {
                    this.noNameFound = true;
                    this.modalBtnLabel.disabled = true;
                } else if (this.validateClassName()) {
                    this.noNameFound = false;
                    this.modalBtnLabel.disabled = false;
                    className = this.classNameFromEdit.charAt(0).toUpperCase() + this.classNameFromEdit.slice(1);
                    this.checkDuplicates(className);
                }
            } else {
                this.modalBtnLabel.disabled = true;
                this.noNameFound = true;
            }
        },
        disabledSavebtn: {
            handler(value) {
                if (!this.invalidPattern) {
                    this.modalBtnLabel.disabled = value;
                }
            },
            immediate: true
        },
        showAddEditData: {
            handler(value) {
                this.showModal = value;
            },
            immediate: true
        }
    },

    mounted() {
        this.$root.$on("actionAttribute", value => {
            this.addEditAttribute(value);
        });
        const findClass = { ...this.parentClassArray.find(elem => elem.id === this.classUuid) };
        this.initialClassData = JSON.parse(JSON.stringify(findClass));
        this.initialBCReady = !!this.isBCReadyFromEdit;
        this.actionsDlg.bind(this);
    },
    methods: {
        ...mapMutations("main", ["setInterfaceDirty"]),
        openAttrAddClass(elem, index) {
            const obj = {
                payload: elem,
                indexAtt: index,
                type: "SELECTED_CONTAINER_CHILD_NEW"
            };
            this.$emit("FABRIC_DIAGRAM_EVENT", obj);
        },
        openEditAtribute(attr, idx) {
            let classId = null;
            this.addAtributeClass = this.parentClassArray.find((el) => el.name === this.initialClassName);
            for (let i = 0; i < this.parentClassArray.length; i++) {
                this.selectedAttr = this.parentClassArray[i].fields.find((el, index) => el.id === attr.id && index === idx);
                if (this.selectedAttr) {
                    classId = this.parentClassArray[i].id;
                    break;
                }
            }
            const obj = {
                payload: {
                    childPluginUuid: attr && this.isInEdit ? attr.id : null, // tipul elementului
                    pluginUuid: classId || null, // id ul elementului
                    indexAtt: idx
                },
                type: "SELECTED_CONTAINER_CHILD"
            };
            this.$emit("FABRIC_DIAGRAM_EVENT", obj);
        },
        openAddAtribute() {
            this.addAtributeClass = this.parentClassArray.find(el => el.name === this.initialClassName);
            const obj = {
                payload: {
                    elem: "ADD",
                    pluginId: "DATA_MODEL_CLASS", // tipul elementului
                    pluginUuid: this.addAtributeClass && this.addAtributeClass.id ? this.addAtributeClass.id : null,
                    className: this.addAtributeClass && this.addAtributeClass.name ? this.addAtributeClass.name : null, // id ul elementului
                    indexAtt: null,
                    atrributeObject: this.attrObject
                },
                type: "CONTAINER_ADD_CHILD"
            };
            this.$emit("FABRIC_DIAGRAM_EVENT", obj);
        },

        addEditAttribute(value) {
            const { index, field, action } = value;
            if (action === "delete") {
                this.attrObject.splice(index, 1);
                if (this.attrObject.length === 0) {
                    this.modalBtnLabel.disabled = true;
                }
            } else if (index || index === 0) {
                this.$set(this.attrObject, index, field);
            } else {
                this.attrObject.push(field);

                this.attrObject.sort((a, b) => {
                    const attributeNameA = a.propertyName.toLowerCase();
                    const attributeNameB = b.propertyName.toLowerCase();
                    if (attributeNameA < attributeNameB) return -1;
                    if (attributeNameA > attributeNameB) return 1;
                    return 0;
                });
            }
            if (this.modalBtnLabel.disabled && this.newClassName && !this.classNameError && this.attrObject.length) {
                this.modalBtnLabel.disabled = false;
            }
        },

        closeModal() {
            this.showModal = false;
            if (!this.noPropDialogToShow) {
                this.$emit("afterCloseModalAdd", { isInEdit: this.isInEdit, sendBlockChainToggle: this.sendBlockChainToggle });
                const payload = {
                    className: this.newClassName,
                    elem: "ADD",
                    pluginId: "DATA_MODEL_CLASS",
                    pluginUuid: this.classUuid
                };
                this.$emit("update:parentClassData", payload);
            } else {
                this.$emit("afterCloseModalAdd", this.dialogPayload);
            }
        },
        attributesHasChanged() {
            let isEqual = true;
            if (this.addAtributeClass && this.addAtributeClass.fields && this.initialClassData && this.initialClassData.fields) {
                if (this.addAtributeClass.fields.length !== this.initialClassData.fields.length) {
                    isEqual = false;
                } else {
                    for (let i = 0; i < this.initialClassData.fields.length; i++) {
                        if (JSON.stringify(this.initialClassData.fields[i]) !== JSON.stringify(this.addAtributeClass.fields[i])) {
                            isEqual = false;
                        }
                    }
                }
            }
            return isEqual;
        },
        validateClassName() {
            let isValid = true;
            const validatePattern = new RegExp(CHECK_NAME_REGEX_STARTING_ALPHA_ONLY);
            const itemToCheck = this.isInEdit ? this.computedClassNameFromEdit : this.newClassName;
            if (itemToCheck && !validatePattern.test(itemToCheck)) {
                this.invalidPattern = true;
                isValid = false;
                this.modalBtnLabel.disabled = true;
            } else {
                this.modalBtnLabel.disabled = false;
                this.invalidPattern = false;
            }
            return isValid;
        },
        actionsDlg($event) {
            if ($event === "primary") {
                // parcurgere obiect de attr si salvarea celor care au flag
                const isValid = this.validateClassName();

                if (!isValid) {
                    this.showModal = true;
                } else {
                    this.$emit("update:noAddingYet", false);
                    // edit clasa
                    if (this.isInEdit) {
                        this.noPropDialogToShow = true;
                        if (this.initialClassName !== this.classNameFromEdit) {
                            for (let i = 0; i < this.parentClassArray.length; i++) {
                                for (let j = 0; j < this.parentClassArray[i].fields.length; j++) {
                                    if (this.initialClassName === this.parentClassArray[i].fields[j].type) {
                                        // eslint-disable-next-line vue/no-mutating-props
                                        this.parentClassArray[i].fields[j].type = this.classNameFromEdit;
                                    }
                                }
                            }
                        }
                        const addClassNew = {
                            className: this.isInEdit ? this.classNameFromEdit : this.newClassName,
                            blockchain: this.isInEdit ? this.isBCReadyFromEdit : this.checked,
                            uuid: this.classUuid
                        };
                        this.$emit("addClass", addClassNew);
                        this.$emit("update:temporaryClassInfo", { ...this.classToAdd, ...addClassNew });
                        this.$emit("update:isInEdit", false);
                        this.$emit("input", true);
                        this.$emit("dataModelSaveClass", true);
                        this.closeModal();
                    } else {
                        // cazul de add new class
                        const uuid = shortId.uuid();
                        this.noPropDialogToShow = false;
                        this.hasChanges = false;
                        this.sendBlockChainToggle = this.checked;
                        this.$emit("addAttributes", this.attrObject);

                        this.$emit("addClass", {
                            className: this.newClassName,
                            blockchain: this.checked,
                            uuid
                        });
                        this.$emit("update:temporaryClassInfo", this.classToAdd);
                        this.$emit("update:isInEdit", false);
                        this.closeModal();
                        this.$emit("dataModelSaveClass", uuid);
                    }
                    this.$root.$emit("showCheckedSaveBtn", false);
                    this.$store.commit("main/setInterfaceDirty", true);
                }
            } else if ($event === this.$t("diagrams.components.setRules.delete")) {
                this.deleteDialog = true;
                this.noPropDialogToShow = false;
                this.openDialog = true;
            } else if ($event === "close") {
                if (!this.getDataModelList.length) {
                    eventBus.$emit("setDefaultState", true);
                }
                if (this.hasChanges || !this.modalBtnLabel.disabled || !this.attributesHasChanged()) {
                    this.deleteDialog = false;
                    this.openDialog = true;
                } else {
                    this.showModal = false;
                }
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        okAction() {
            if (this.deleteDialog) {
                this.$emit("deleteClass", this.classUuid);
            } else {
                this.$emit("setParentClassArray", {
                    ...this.initialClassData

                }, "closeModal");
                this.$emit("update:isBCReadyFromEdit", this.initialBCReady);
                this.$store.commit("main/setInterfaceDirty", false);
                this.modalBtnLabel.disabled = true;
                this.noPropDialogToShow = true;
                this.showModal = false;
                this.hasChanges = false;
                this.$emit("afterCloseModalAdd", "fromCloseModal");
            }
        },
        cancelAction() {
            this.openDialog = false;
        },

        checkDuplicates(className) {
            this.noNameFound = false;
            const foundClassName = this.parentClassArray.find(element => className === element.name && this.classUuid !== element.id);
            const foundCatalogName = this.existingCatalogsAsList.find(({ label }) => label === className);
            const foundTypeName = this.columnDataTypesWithAttDDL.find(elem => elem.label === className && elem.value !== "bt");

            if (foundTypeName) {
                this.duplicateInTypes = true;
                this.modalBtnLabel.disabled = true;
                this.duplicateTypeName = foundTypeName.label;
            } else if (foundCatalogName) {
                this.duplicateInCatalogs = true;
                this.modalBtnLabel.disabled = true;
                this.duplicateCatName = foundCatalogName.label;
            } else if (foundClassName) {
                this.duplicatedClassName = true;
                this.modalBtnLabel.disabled = true;
                this.duplicatedClassNameLabel = foundClassName.name;
            } else {
                this.duplicateInTypes = false;
                this.duplicateInCatalogs = false;
                this.duplicatedClassName = false;
            }
        }
    }
};
